import type { IconNode } from '../types';

/**
 * @name horse-head
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEuNSAxMkgxMSIgLz4KICA8cGF0aCBkPSJNNSAxNWE0IDQgMCAwIDAgNCA0aDcuOGwuMy4zYTMgMyAwIDAgMCA0LTQuNDZMMTIgN2MwLTMtMS01LTEtNVM4IDMgOCA3Yy00IDEtNiAzLTYgMyIgLz4KICA8cGF0aCBkPSJNNi4xNCAxNy44UzQgMTkgMiAyMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/horse-head
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const horseHead: IconNode = [
  ['path', { d: 'M11.5 12H11', key: 'dwhguf' }],
  [
    'path',
    {
      d: 'M5 15a4 4 0 0 0 4 4h7.8l.3.3a3 3 0 0 0 4-4.46L12 7c0-3-1-5-1-5S8 3 8 7c-4 1-6 3-6 3',
      key: '571my3',
    },
  ],
  ['path', { d: 'M6.14 17.8S4 19 2 22', key: 'l04gdj' }],
];

export default horseHead;
